"use client";
import {
  Flex,
  Heading,
  ListItem,
  Text,
  UnorderedList,
  useMediaQuery,
} from "@chakra-ui/react";
import { ArrowBanner, ArrowProps } from "@ui/components/arrow-banner";
import { SectionTemplate } from "components/individuals/blocks";

export interface EnterpriseArrowBannersSectionProps {
  title: string;
  subtitle: string;
  bg: string;
  titleColor: string;
  subtitleColor: string;
  arrowBanners: ArrowProps[];
}

export const EnterpriseArrowBannersSection = ({
  title,
  subtitle,
  bg,
  titleColor,
  subtitleColor,
  arrowBanners,
}: EnterpriseArrowBannersSectionProps) => {
  const [isLargeBp] = useMediaQuery("(min-width: 992px)");
  return (
    <SectionTemplate bg={bg}>
      <Heading
        as={"h2"}
        color={titleColor}
        fontSize={{
          base: 26,
          md: 34,
          lg: 38,
          xl: 45,
        }}
        fontWeight={"bold"}
        lineHeight={{
          base: 1.1,
          lg: 1.2,
        }}
        mb={{
          base: 6,
          lg: 8,
        }}
        w={{
          base: "full",
          lg: "90%",
          xl: "75%",
        }}
      >
        {title}
      </Heading>
      <Text
        as={"h3"}
        color={subtitleColor}
        fontSize={{
          base: 16,
          md: 18,
          lg: 20,
          xl: 22,
        }}
        fontWeight={"bold"}
        pb={12}
      >
        {subtitle}
      </Text>
      <Flex justifyContent={"center"} flexDir={"column"}>
        <Flex
          flexDir={"row"}
          gap={{
            base: 3,
            sm: 5,
            md: 10,
            lg: 14,
            xl: 20,
          }}
          w={{
            base: "91%",
            md: "90%",
            lg: "93%",
          }}
        >
          {arrowBanners.map((arrow, idx) => (
            <ArrowBanner key={idx} {...arrow} bg={bg} zIndex={5 - idx} />
          ))}
        </Flex>
        {isLargeBp ? (
          <Flex
            flexDir={"row"}
            gap={{
              lg: 32,
            }}
            pt={{
              md: 6,
              lg: 10,
            }}
            w={{
              lg: "95%",
            }}
            mx={"auto"}
            pr={{ lg: 10 }}
          >
            {arrowBanners.map((arrow, idx) => (
              <Text
                key={idx}
                color={arrow.descriptionColor}
                fontSize={{
                  base: 14,
                  md: 16,
                  lg: 17,
                  xl: 18,
                }}
                pl={{
                  lg: idx === 1 ? 6 : "",
                }}
              >
                {arrow.description}
              </Text>
            ))}
          </Flex>
        ) : (
          <>
            <UnorderedList spacing={3}>
              {arrowBanners.map((arrow, idx) => (
                <ListItem key={idx} fontSize={14}>
                  {arrow.description}
                </ListItem>
              ))}
            </UnorderedList>
          </>
        )}
      </Flex>
    </SectionTemplate>
  );
};
